<!-- <div *ngIf="profil === 1 || profil === 5"> -->

<div class="m-6">
  <div class="mb-3">
    <div class="text-3xl text-gray-900 font-semibold mb-2">
      Bonjour {{ nom + " " + prenom }} !
    </div>
    <p>Bienvenue dans le programme FORCE-N.</p>
  </div>
  <br />

  <div class="subtitle mt-2" *ngIf="cohorte != null">
    <!-- <div class="subtitle mt-2" *ngIf="cohorte ==='SIG2509-FODE'"> -->
    <div class="text-2xl font-semibold text-gray-900">Test de personnalité</div>
  </div>
  <!-- <div class="card shadow grid grid-cols-1 sm:grid-cols-2 gap-3 mt-3 m-0">
      <div class="step-personality px-2 sm:border-right-1 sm:border-200">
        <div class="title font-semibold text-xl mb-2">Étape 1</div>
        <div>Cliquez sur le <a class="link font-semibold underline" href="https://www.16personalities.com/fr/test-de-personnalite" target="_blank" title="lien">lien</a> pour effectuer votre test de personnalité.</div>
      </div>
      <div class="step-personality px-2">
        <div class="title font-semibold text-xl mb-2">Étape 2</div>
        <div class="label mb-1">Saisissez le code reçu au bon format
          <div style="color:var(--blue);" class="tooltip pi pi-info-circle">
            <div class="tooltip-text text-sm">Ne renseignez que les 4 premiers caractères du code reçu. Exemple : ESTJ, ENTJ, ISFP.</div>
          </div>
        </div>
        <input formControlName="selectedCode" type="text" placeholder="Ex : ENTJ"  class="mb-1 bg-white border border-gray-300 text-gray-900 text-sm rounded-lg inline-block w-4 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 h-15 mr-2" />
        <p *ngIf="" class="text-red text-sm"> Code Invalide</p>
        <button type="button" class="text-white btn-login rounded-lg text-sm px-5 py-2.5 bg-blue font-semibold">
          Valider
        </button>
      </div>
    </div> -->

  <!-- <div *ngIf="inCohorte"> -->
  <!-- <div *ngIf="cohorte === 'SIG2509-FODE'"> -->
  <div *ngIf="cohorte != null">
    <app-test-personnality></app-test-personnality>
  </div>

  <div class="subtitle mt-12" *ngIf="!gestionnaireBenin">
    <div class="text-2xl font-semibold text-gray-900">Accès rapide</div>
  </div>
  <div
    *ngIf="!gestionnaireBenin"
    class="grid grid-cols-1 acces-rapide-ctnr sm:grid-cols-2 lg:grid-cols-3 gap-3 mt-3 ml-0"
  >
    <div
      *ngFor="let item of filteredAccesRapides"
      class="card shadow mb-0 link transition"
    >
      <a class="cst-transition rounded-lg" [routerLink]="item.link">
        <p class="flex p-2 text-center text-red-500" *ngIf="item.urgence != ''">
          !! {{ item.urgence }} !!
        </p>
        <div class="flex p-2">
          <div class="icons mr-3">
            <img [src]="'assets/icons/' + item.icon" />
          </div>
          <div class="content">
            <div class="text-xl titre text-gray-950 pt-0 lg:pt-2 font-semibold">
              {{ item.title }}
            </div>
            <div class="text-gray-500 desc pt-1 font-semibold">
              {{ item.subtitle }}
            </div>
          </div>
        </div>
      </a>
    </div>
  </div>

  <!-- Barre de progression horizontale -->
  <div *ngIf="inCohorte">
    <div class="subtitle mt-12">
      <div class="text-2xl font-semibold text-gray-900 mb-3">
        Ma progression
      </div>
    </div>
    <div class="progress-bar-ctnr pb-6 m-3 ml-0">
      <div class="w-full bg-white p-3 shadow rounded-lg border-gray-300 pt-6">
        <ol class="progress-bar">
          <li class="is-current">
            <span class="circle cst-transition cst-before cst-after"></span>
            <h4
              class="titre cst-transition font-semibold my-1 f14 color-gray-700 pr-db cst-transition"
            >
              Onboarding
            </h4>
            <div
              class="desc font-semibold w-full f14 color-gray-600 pr-db cst-transition"
            >
              <a class="text-gray-500" href="">En savoir plus sur les étapes</a>
            </div>
          </li>
          <li class="text-center">
            <span class="circle cst-transition cst-before cst-after"></span>
            <h4
              class="titre cst-transition font-semibold my-1 f14 color-gray-700 pr-db cst-transition"
            >
              Ukumbi
            </h4>
            <div
              class="desc font-semibold w-full f14 color-gray-600 pr-db cst-transition"
            >
              <a class="text-gray-500" href="">En savoir plus sur les étapes</a>
            </div>
          </li>
          <li class="text-right">
            <span class="circle cst-transition cst-before cst-after"></span>
            <h4
              class="titre cst-transition font-semibold my-1 f14 color-gray-700 pr-db cst-transition"
            >
              Ujaama
            </h4>
            <div
              class="desc font-semibold w-full f14 color-gray-600 pr-db cst-transition"
            >
              <a class="text-gray-500" href="">En savoir plus sur les étapes</a>
            </div>
          </li>
        </ol>
      </div>
    </div>
  </div>

  <!-- !Barre de progression horizontale -->

  <!-- Barre de progression verticale -->
  <!-- <div class="progress-bar-ctnr pt-6 pb-6 m-3">
      <div class="w-full bg-white p-6 shadow rounded-lg border-gray-300">
        <ul class="progress-bar verticale pt-6">
          <li class="is-current">
            <span class="circle cst-transition cst-before cst-after"></span>
            <h4 class="titre cst-transition font-medium inter-semibold mb10 f14 color-gray-700 pr-db cst-transition ">Onboarding</h4>
            <div class="desc font-normal inter-regular w-full f14 color-gray-600 pr-db cst-transition ">Derim gradur ergum ut</div>
          </li>
          <li class="text-center">
            <span class="circle cst-transition cst-before cst-after"></span>
            <h4 class="titre cst-transition font-medium inter-semibold mb10 f14 color-gray-700 pr-db cst-transition ">Etape 2</h4>
            <div class="desc font-normal inter-regular w-full f14 color-gray-600 pr-db cst-transition ">Lorem pririt ergum ut</div>
          </li>
          <li class="text-center">
            <span class="circle cst-transition cst-before cst-after"></span>
            <h4 class="titre cst-transition font-medium inter-semibold mb10 f14 color-gray-700 pr-db cst-transition ">Etape 3</h4>
            <div class="desc font-normal inter-regular w-full f14 color-gray-600 pr-db cst-transition ">Consectetur pririt ergum ut</div>
          </li>
          <li class="text-center">
            <span class="circle cst-transition cst-before cst-after"></span>
            <h4 class="titre cst-transition font-medium inter-semibold mb10 f14 color-gray-700 pr-db cst-transition ">Etape 4</h4>
            <div class="desc font-normal inter-regular w-full f14 color-gray-600 pr-db cst-transition ">Consectetur pririt ergum ut</div>
          </li>
        </ul>
      </div>
    </div> -->
  <!-- !Barre de progression verticale -->

  <!-- <div class="flex justify-between mr-3">
      <div class="text-2xl font-medium text-gray-900 dark:text-white ml-3">
        Appels à canditature
      </div>
      <div class="flex bg-white border border-gray-300 rounded p-2 ml-6">
        <a [routerLink]="['/dashboard/appels']" class="flex">
          <svg
            class="w-5 h-5 text-gray-800 dark:text-white"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 20 19"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m9 12 5.419 3.871A1 1 0 0 0 16 15.057V2.943a1 1 0 0 0-1.581-.814L9 6m0 6V6m0 6H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h7m-5 6h3v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-5Zm15-3a3 3 0 0 1-3 3V6a3 3 0 0 1 3 3Z"
            />
          </svg>
          <span class="ms-2 text-sm text-gray-900 dark:text-white"
            >Tous les appels</span
          >
        </a>
      </div>
    </div> -->

  <!-- <div
    *ngFor="let item of progressBar"
    class="shadow border-1 border-gray-300 rounded-lg dark:border-gray-600 bg-white m-3 placeholder-zinc-600 p-6"
  >

  <a [routerLink]="item.link">
    <div class="flex">
      <div class="icons">
        <img [src]="'assets/icons/' + item.icon " />
      </div>
      <div class="content">
        <div class="text-2xl text-gray-950 dark:text-white">
          {{ item.title }}
        </div>
        <div class="text-gray-500 pt-3">{{ item.subtitle }}</div>
      </div>
    </div>
  </a>

  </div> -->

  <!-- <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 mb-4">
      <div
        class="bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700 m-6"
        *ngFor="let appel of appels"
      >
        <figure class="relative">
          <a [routerLink]="['/dashboard/appels/soumission/' + appel.id]">
            <img
              class="rounded-t-lg"
              src="assets/img/image-3.png"
              alt=""
              width="100%"
            />
            <figcaption class="absolute px-4 text-lg text-white top-2 rounded">
              <a
                routerLink="/register"
                class="mb-6 px-3 py-2 text-sm font-medium text-center text-white bg-green-500 rounded-full hover:bg-green-500 focus:ring-4 focus:outline-none focus:ring-green-300 dark:bg-green-500 dark:hover:bg-green-600 dark:focus:ring-green-600"
              >
                Inscriptions en cours
              </a>
            </figcaption>
          </a>
        </figure>
        <div class="p-5">
          <a href="#">
            <div class="mb-2 text-xl text-gray-900 dark:text-white">
              {{ appel.applicationName }}
            </div>
          </a>
          <p class="mb-3 font-normal text-gray-700 dark:text-gray-400">
            {{ appel.applicationInformations }}
          </p>
          <a
            [routerLink]="['/dashboard/appels/soumission/' + appel.id]"
            class="inline-flex float-right mb-6 px-3 py-2 text-sm font-medium text-center text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
          >
            Continuer
            <svg
              class="rtl:rotate-180 w-3.5 h-3.5 ms-2 mt-1"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 14 10"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M1 5h12m0 0L9 1m4 4L9 9"
              />
            </svg>
          </a>
        </div>
      </div>
    </div> -->
</div>
<!-- <div
    style="
      width: 100%;
      height: 100%;
      padding: 32px;
      background: #f4f4f4;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      gap: 10px;
      display: inline-flex;
    "
  > -->
<!-- <div class="mb-3">
      <div class="text-3xl text-gray-900 font-normal dark:text-white">
        Bonjour {{ nom + " " + prenom }} !
      </div>
      <p>Bienvenue dans le programme FORCE-N..!</p>
    </div> -->

<!-- </div> -->

<!-- <div *ngIf="profil === 4">
    <app-jeandashboard></app-jeandashboard>
  </div> -->
